namespace $ {
	export class $shm_projects_digest_api extends $mol_object2 {
		static refresh( kind: 'day' | 'week', date: string ) {
			return this.$.$shm_projects_goal_api.json({ action: 'digest_refresh', kind, date }) as Promise<$shm_projects_digest_record>
		}
	}
}
